import { render, staticRenderFns } from "./CatalogSliderItem.vue?vue&type=template&id=c48e2c2c&scoped=true&"
import script from "./CatalogSliderItem.vue?vue&type=script&lang=js&"
export * from "./CatalogSliderItem.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSliderItem.vue?vue&type=style&index=0&id=c48e2c2c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48e2c2c",
  null
  
)

export default component.exports